import { render } from "./OutlaysCategories.vue?vue&type=template&id=670b64b9"
import script from "./OutlaysCategories.vue?vue&type=script&lang=js"
export * from "./OutlaysCategories.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__